import api from "../../services/api";

export const getExamOptions = async () => {
  const response = await api.get("teacher/exams/options/");
  return response.data;
};

export const getExamModules = async ({ matiere, classe }) => {
  const response = await api.get("teacher/exams/modules/", {
    params: { matiere, classe },
  });
  return Array.isArray(response.data?.modules) ? response.data.modules : [];
};

export const getExamLessons = async (moduleIds) => {
  const response = await api.get("teacher/exams/lessons/", {
    params: { modules: moduleIds.join(",") },
  });
  return Array.isArray(response.data?.lessons) ? response.data.lessons : [];
};

export const getTeacherEstablishments = async () => {
  const response = await api.get("teacher/establishments/");
  return Array.isArray(response.data?.establishments) ? response.data.establishments : [];
};

export const getExamStructure = async ({ matiere, classe }) => {
  const response = await api.get("teacher/exams/structure/", { params: { matiere, classe } });
  return response.data.positions || [];
};

const establishmentForm = ({ nom, adresse = "", sous_tutelle = "", logo }) => {
  const form = new FormData();
  form.append("nom", nom);
  form.append("adresse", adresse);
  form.append("sous_tutelle", sous_tutelle);
  if (logo) form.append("logo", logo);
  return form;
};

export const createTeacherEstablishment = async (values) => {
  const response = await api.post("teacher/establishments/", establishmentForm(values));
  return response.data;
};

export const updateTeacherEstablishment = async (id, values) => {
  const response = await api.patch(`teacher/establishments/${id}/`, establishmentForm(values));
  return response.data;
};
